/**
 * ProgressBar.jsx — eye-test grid render-job progress strip.
 *
 * Extracted verbatim from RenderingStudioLegacyGrid.jsx (§6.6 A1).
 * Shows job status, a fill bar (done/total), the success/skipped/failed
 * summary, finished-at time, the mock-TTS flag, and any polling error.
 */

import React from "react";
import { Message } from "semantic-ui-react";
import { cellStatusClass } from "./gridUtils";

const ProgressBar = ({ job, error }) => {
  if (!job) return null;
  const { totalCells = 0, summary = {}, status, finishedAt } = job;
  const done =
    (summary.success || 0) + (summary.failed || 0) + (summary.skipped || 0);
  const pct = totalCells > 0 ? Math.round((done / totalCells) * 100) : 0;
  const stateClass =
    status === "complete" ? "s-complete" : status === "failed" ? "s-failed" : "";
  return (
    <div className={`progress-shell ${stateClass}`}>
      <div>
        <strong>Render job:</strong>{" "}
        <span
          className={`grid-cell-status ${cellStatusClass(
            status === "running" ? "rendering" : status
          )}`}
        >
          {status}
        </span>
      </div>
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="progress-meta">
        <span>
          {done}/{totalCells} cells
        </span>
        <span>✔ {summary.success || 0}</span>
        <span>⏭ {summary.skipped || 0}</span>
        <span>✖ {summary.failed || 0}</span>
        {finishedAt && (
          <span>finished {new Date(finishedAt).toLocaleTimeString()}</span>
        )}
        {job.elevenLabsMock && <span style={{ color: "#8a6d00" }}>(mock TTS)</span>}
      </div>
      {error && (
        <Message
          warning
          size="tiny"
          style={{ marginTop: 8 }}
          content={`Polling: ${error}`}
        />
      )}
    </div>
  );
};

export default ProgressBar;
